// import googleMapReact from "google-map-react";
import React, { useEffect, useState } from "react";
// import jwt_decode from "jwt-decode";
import { Redirect, Link } from "react-router-dom";
import { useGoogleLogin, GoogleLogin } from "@react-oauth/google";
import {
  googleLoginSuccess,
  googleLoginFail,
} from "../../redux/actions/google_auth";
import axios from "axios";
import "../../assets/styles/login.scss";

import {
  Col,
  Button,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
} from "reactstrap";
import { useDispatch } from "react-redux";
import GoogleButton from "react-google-button";

const LoginComponent = ({ authData, clearRedirect, redirect }) => {
  const dispatch = useDispatch();
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      console.log(tokenResponse);
      try {
        const userData = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `${tokenResponse.token_type} ${tokenResponse.access_token}`,
            },
          }
        );
        dispatch(googleLoginSuccess(userData.data));
      } catch (error) {
        dispatch(googleLoginFail(error));
      }
    },
    onError: (errorResponse) => {
      console.log(errorResponse);
      dispatch(googleLoginFail(errorResponse));
    },
  });
  const KAKAO_AUTH_URL = `https://kauth.kakao.com/oauth/authorize?client_id=${process.env.REACT_APP_KAKAO_REST_API_KEY}&redirect_uri=${process.env.REACT_APP_KAKAO_REDIRECT_URI}&response_type=code`;
  // console.log(authData);
  // console.log(clearRedirect);
  // console.log(redirect);
  if (authData.isSignedIn) {
    let redirect_path = redirect.path;
    clearRedirect();
    return <Redirect to={redirect_path} />;
  }

  return (
    <Container>
      <Col sm={10} md={8} lg={6} className="mx-auto d-table h-100 mt-5 pt-3">
        <div className="d-table-cell align-middle">
          <Card className="auth_card mb-3">
            <CardBody className="pt-0">
              <div className="text-center mt-4">
                <Link to="/">
                  <img
                    src={require("../../assets/img/logo_navbar_dark.png")}
                    width="200"
                    height="45"
                    alt="navbar_dark"
                  />
                </Link>
              </div>
              <div className="login-button-container">
                {/* <GoogleLogin
                  onSuccess={(credentialResponse) => {
                    console.log(credentialResponse);
                    dispatch(googleLoginSuccess(credentialResponse));
                  }}
                  onError={(errorResponse) => {
                    console.log(errorResponse);
                    dispatch(googleLoginFail(errorResponse));
                  }}
                  text="continue_with"
                  theme="outline"
                  size="large"
                  shape="rectangular"
                  width="400"
                /> */}
                <Button onClick={login} className="google-login-button">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 48 48"
                    // class="LgbsSe-Bz112c"
                    width="24"
                    fill="none"
                  >
                    <g>
                      <path
                        fill="#EA4335"
                        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
                      ></path>
                      <path
                        fill="#4285F4"
                        d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
                      ></path>
                      <path
                        fill="#FBBC05"
                        d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
                      ></path>
                      <path
                        fill="#34A853"
                        d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
                      ></path>
                      <path fill="none" d="M0 0h48v48H0z"></path>
                    </g>
                  </svg>
                  Google로 계속하기
                </Button>
                {/* <GoogleButton
                  className="google-login-button"
                  type="light" // can be light or dark
                  onClick={login}
                /> */}
                <a href={KAKAO_AUTH_URL}>
                  <Button className="kakao-login-button">
                    <svg
                      data-v-4b7d2f5e=""
                      width="24"
                      height="24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="kakao__icon"
                    >
                      <path
                        data-v-4b7d2f5e=""
                        d="M11.998 4c-5.387 0-9.753 3.443-9.753 7.69 0 2.746 1.826 5.158 4.572 6.516-.15.515-.96 3.314-.992 3.535 0 0-.02.165.087.227a.295.295 0 00.232.015c.308-.044 3.564-2.327 4.127-2.72.572.08 1.15.118 1.727.117 5.387 0 9.754-3.443 9.754-7.69S17.384 4 11.998 4z"
                        fill="#000"
                        fill-opacity=".9"
                      ></path>
                    </svg>
                    카카오로 시작하기
                  </Button>
                </a>
              </div>
            </CardBody>
          </Card>
        </div>
      </Col>
    </Container>
  );
};

export default LoginComponent;
